// Account base route

// export const BASE_URL = 'http://localhost:3221/api/v1'
export const BASE_URL = 'https://www.scycloud.ch/api/v1'

export interface ApiResponse {
  ok: boolean
  statusCode: number
  statusMessage: string
  message: string | null
}
